import { ForceTheme } from 'src/common/components/force-theme';
import { ThemeColorMode } from 'src/common/enums';
import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';
import { SubscribeNowLabel, useTrackSubscribeNow } from 'src/features/campaigns/hooks/use-track-subscribe-now';
import { Countdown } from '../../components/countdown';
import { CopyType, getModalCopy } from '../modal/modal.constants';
import { SubscribeButton } from '../subscribe-button';
import { StyledBadgeMessage, StyledBanner, StyledButtons, StyledCertificatesImage, StyledCountdownContainer, StyledSubTitle, StyledSubTitleAlt, StyledTitle } from './banner.styles';
import type { CertificationsFlashSaleProps } from './banner.types';
export const CertificationsFlashSaleBanner = ({
  title,
  subtitle,
  subtitleAlt,
  isLarge,
  ctaLabel,
  ctaName,
  onCtaClick,
  isPremium
}: CertificationsFlashSaleProps) => {
  const {
    campaign
  } = useActiveCampaign();
  const trackSubscribeNow = useTrackSubscribeNow();
  if (!campaign) return null;
  const onClick = () => {
    trackSubscribeNow(ctaName);
    onCtaClick?.();
  };
  return <ForceTheme themeMode={ThemeColorMode.DARK} data-sentry-element="ForceTheme" data-sentry-component="CertificationsFlashSaleBanner" data-sentry-source-file="banner.tsx">
      <StyledBanner data-sentry-element="StyledBanner" data-sentry-source-file="banner.tsx">
        <StyledCertificatesImage $large={isLarge} alt="" aria-hidden="true" data-sentry-element="StyledCertificatesImage" data-sentry-source-file="banner.tsx" />
        <StyledTitle data-testid="campaign-title" data-sentry-element="StyledTitle" data-sentry-source-file="banner.tsx">{title}</StyledTitle>
        {subtitle && <StyledSubTitle data-testid="campaign-promotion-text">{subtitle}</StyledSubTitle>}
        {subtitleAlt && <StyledSubTitleAlt data-testid="campaign-promotion-text-alt">{subtitleAlt}</StyledSubTitleAlt>}
        <StyledCountdownContainer data-sentry-element="StyledCountdownContainer" data-sentry-source-file="banner.tsx">
          <Countdown vertical dark includeDays endTime={campaign.endTime} data-sentry-element="Countdown" data-sentry-source-file="banner.tsx" />
        </StyledCountdownContainer>
        {!isPremium && <StyledBadgeMessage>3 months Premium access included</StyledBadgeMessage>}
        <StyledButtons data-sentry-element="StyledButtons" data-sentry-source-file="banner.tsx">
          <SubscribeButton to="/certifications" aria-label={ctaLabel} onClick={onClick} data-sentry-element="SubscribeButton" data-sentry-source-file="banner.tsx">
            {ctaLabel}
          </SubscribeButton>
        </StyledButtons>
      </StyledBanner>
    </ForceTheme>;
};
export const withModalStyling = (BaseComponent: typeof CertificationsFlashSaleBanner) => {
  return function ModalCampaignBanner(props: {
    onClick: () => void;
    occupation?: string;
    isPremium?: boolean;
  }) {
    const {
      isPremium,
      occupation,
      onClick
    } = props;
    const copy = getModalCopy(isPremium ? CopyType.PREMIUM : CopyType.FREE, occupation);
    return <BaseComponent title={copy.title} subtitle={copy.subtitle} subtitleAlt={undefined} isLarge={false} isPremium={isPremium} ctaLabel="Get certified" ctaName={SubscribeNowLabel.FlashSaleModal} onCtaClick={onClick} />;
  };
};